import * as Sentry from '@sentry/browser';

import Logger from '@evidentid/logger';
import ConsoleLoggerAdapter from '@evidentid/logger/adapters/ConsoleLoggerAdapter';
import SentryLoggerAdapter from '@evidentid/logger/adapters/SentryLoggerAdapter';
import LoggerUserData from '@evidentid/logger/LoggerUserData';

// The structural surface SentryLoggerAdapter actually uses; accepts the
// namespace of @sentry/browser or @sentry/vue alike.
type SentryLike = Pick<typeof Sentry, 'addBreadcrumb' | 'setUser' | 'setTag'>;

export default function createLogger<L extends LoggerUserData = LoggerUserData>(sentry: SentryLike | null) {
    // eslint-disable-next-line
    // @ts-ignore: it may be different Sentry library
    const adapter = sentry ? new SentryLoggerAdapter(sentry) : new ConsoleLoggerAdapter();
    return new Logger<L>(adapter);
}
